<template>
    <span :id="'render_' + name"></span>
</template>

<script>
import axios from 'axios';

export default {
    name: 'kxd-render',
    props: ['name', 'text', 'options', 'pane', 'cursor_latlng', 'colorbar'],
    data: function() {
        return {
            render_max: this.options.render_max || 100, //最大圖層數, 超過會清掉最舊圖層
            projection: 'EPSG3857',
            color_csv: this.options.color_csv || 'hgt', //multi產品可設定顏色來自 spd|hgt
            layer: L.xCanvasOverlay({ pane: this.name }, X.canvasType.match_parent).addTo(this.pane),
            is_layer_show: true,
            render: null,
            render_color_status: this.pane.options.render_hint.render_color_status || null, //預設關閉色階
        }
    },
    computed: {
        has_colorbar: function(params) {
            //是否產製colorbar, symbol_wind產品無colorbar
            if (this.render_type === 'symbol_wind') return false
            return this.pane.options.render_hint?.colorbar?.show === false ? false : true
        },
        layer_id: function() {
            return this.layer._leaflet_id
        },
        render_type: function() {
            return this.options.type
        },
        pick_data: function() {
            if (!this.render || !this.is_layer_show || !this.has_colorbar) {
                return null
            }

            return this.render.pickData(this.cursor_latlng.lng, this.cursor_latlng.lat)
        },
    },
    beforeMount: function() {},
    mounted: function() {
        this.initial_render()
    },
    methods: {
        initial_render: function() {
            axios.get(this.options.header).then((csv) => {
                this.create_cycle_render(csv.data)
            })
        },
        create_cycle_render: function(header_csv) {
            const canvas = this.layer.getElement()
            KXD.utility.func.cnvBuffer.add(this.name, canvas)

            let KXD_render_type, KXD_header
            if (this.render_type === 'pixel') {
                KXD_render_type = 'pixel'
                KXD_header = this.format_data(header_csv)
            } else if (['symbol', 'symbol_wind'].includes(this.render_type)) {
                KXD_render_type = 'symbol'
                KXD_header = this.format_data(header_csv, header_csv)
            } else if (this.render_type === 'multi') {
                KXD_render_type = 'multiData'
                KXD_header = this.format_data(header_csv, header_csv, header_csv)
            }

            this.render = new KXD.CycleRender(
                KXD.utility.enum.renderType[KXD_render_type],
                KXD.utility.enum.renderFunc.quality,
                this.render_max,
                KXD_header,
                this.name,
                KXD.utility.enum.proj[this.projection]
            )

            if (this.render_type === 'symbol') {
                this.render.setMargin(4)
                this.render.setSymbolStyle(KXD.utility.class.symbol.ArrowStyle.createStyle2(23, 36))
            } else if (this.render_type === 'symbol_wind') {
                this.render.setMargin(4)
                let style = this.options.multi_drawer || KXD.utility.class.symbol.WindBarStyle.createDefaultStyle()
                this.pane.options.render_hint.set_style && this.pane.options.render_hint.set_style(style)
                this.render.setSymbolStyle(style)
            } else if (this.render_type === 'multi') {
                let multi_drawer
                if (this.options.multi_drawer) {
                    multi_drawer = this.options.multi_drawer
                } else {
                    multi_drawer = this.initial_multi_drawer
                }

                this.render.setSymbolStyle(multi_drawer)
                this.render.setMargin(1)
                this.render.setFillOut(true)
            }

            this.render.onCycleImageChange(function(i) {})
            this.render.change_by_key = (key) => {
                this.render.changeRenderingImage(key)
                this.pane.render.last_key = key
            }
        },
        initial_multi_drawer: function(headerInfo, transform) {
            //定義multi箭頭, blockSize,render為KXD核心指定名稱, 勿更名
            this.blockSize = 12 //單一箭頭所占大小(含四周空白)

            this.render = function(cnv, val) {
                const ctx = cnv.getContext('2d')
                const theta = (3 * Math.PI) / 2 // 數學上的零度為向右，逆時針旋轉為正
                const arrowLen = transform.others[0](val.others[0]) * 0.9 + 0.5
                const centerXY = this.blockSize / 2

                let theta_tmp
                // 符號中心點
                const ptrX1 = centerXY
                const ptrY1 = centerXY
                // 符號右側尾
                theta_tmp = theta - (5 * Math.PI) / 6
                const ptrX2 = ptrX1 + (Math.cos(theta_tmp) * arrowLen) / 3
                const ptrY2 = ptrY1 - (Math.sin(theta_tmp) * arrowLen) / 3
                // 符號頂點
                const ptrX3 = ptrX1 + (Math.cos(theta) * arrowLen) / 2
                const ptrY3 = ptrY1 - (Math.sin(theta) * arrowLen) / 2
                // 符號左側尾
                theta_tmp = theta + (5 * Math.PI) / 6
                const ptrX4 = ptrX1 + (Math.cos(theta_tmp) * arrowLen) / 3
                const ptrY4 = ptrY1 - (Math.sin(theta_tmp) * arrowLen) / 3

                ctx.beginPath()
                ctx.moveTo(ptrX1, ptrY1)
                ctx.lineTo(ptrX2, ptrY2)
                ctx.lineTo(ptrX3, ptrY3)
                ctx.lineTo(ptrX4, ptrY4)
                ctx.lineTo(ptrX1, ptrY1)
                ctx.stroke()
                ctx.fill()
            }
        },
        set_layer_boundary: function(render = this.render) {
            if (!['symbol', 'symbol_wind', 'multi'].includes(this.render_type)) {
                const dataBounds = render.getDataInfo().boundary
                const canvasBounds = L.latLngBounds(
                    L.latLng(dataBounds.topLat, dataBounds.leftLng),
                    L.latLng(dataBounds.bottomLat, dataBounds.rightLng)
                )

                this.layer.setBounds(canvasBounds)
            }

            this.layer.bridge(render, (renderCanvas, renderObject) => {
                const mapBounds = this.layer._map.getBounds()

                renderObject.setBoundary(
                    mapBounds.getWest(),
                    mapBounds.getNorth(),
                    mapBounds.getEast(),
                    mapBounds.getSouth()
                )
                renderObject.setSize(this.layer._map._size.x, this.layer._map._size.y)
            })
        },
        set_color_status: function() {
            if (!this.render_color_status) {
                return
            }

            this.render_color_status.forEach((status, lv) => {
                if (!status) {
                    this.render.colorSwitch(lv)
                }
            })
        },
        set_colorbar: function(options, render) {
            if (!this.has_colorbar) return

            const header_info = render.getHeaderInfo()
            this.options.colorbar.color_list = this.get_color_list(header_info)
            this.options.colorbar.val_list = this.get_val_list(header_info)
            this.options.colorbar.title = ''
            // this.options.colorbar.title = options.colorbar.title || this.text

            if (this.render_color_status) {
                this.options.colorbar.color_status = this.render_color_status
            }

            this.$emit('create_colorbar', {
                status: true,
                name: this.name,
                setting: options.colorbar,
                switch: (lv, layersDisable) => {
                    render.colorSwitch(lv)

                    if (render.render) {
                        render.render()
                    }

                    // color status 紀錄在pane上
                    this.pane.options.render_hint.render_color_status = layersDisable
                },
                callback: () => {},
            })
        },
        get_color_list: function(header_info) {
            if (this.render_type === 'pixel') {
                return header_info.colorCodeList
            } else if (this.render_type === 'symbol') {
                return header_info.quantity.colorCodeList
            } else if (this.render_type === 'multi') {
                return header_info.color.colorCodeList
            }
        },
        get_val_list: function(header_info) {
            if (this.render_type === 'pixel') {
                return header_info.valList
            } else if (this.render_type === 'symbol') {
                return header_info.quantity.valList
            } else if (this.render_type === 'multi') {
                return header_info.color.valList
            }
        },
        extend_pane_render: function(params) {
            // 擴充方法到pane, for pane 操作
            if (!this.pane.render) {
                this.pane.render = {}
            }

            // set pane.render params
            this.pane.render.last_key = null // 最後顯示的key
            // colorbar switch時, 會更新 this.pane.options.render_hint.render_color_status

            this.pane.render.is_exist = this.is_exist
            this.pane.render.add_data = this.add_data
            this.pane.render.change = this.change
            this.pane.render.remove_render_layer = this.remove_render_layer
            this.pane.render.add_render_layer = this.add_render_layer
        },
        is_exist: function(key) {
            //確認資料是否已存在
            const key_list = this.render.getImageKeyListInOrder()
            return key_list.includes(key)
        },
        add_data: function(options) {
            const data = options.data
            const key = data.key
            let requests = options.requests || []

            if (!data.url) {
                //無路徑時, 該頁插入空值
                this.insert_data(this.render, null, key)
                if (options.callback) {
                    options.callback()
                }
            } else {
                this.get_csv(requests, data, key, (csv_data, key) => {
                    if (csv_data) {
                        this.insert_data(this.render, csv_data, key)
                    } else {
                        //取資料時失敗, 該頁插入空值
                        this.insert_data(this.render, null, key)
                    }

                    if (options.callback) {
                        options.callback()
                    }
                })
            }
        },
        get_csv: function(
            //同產品的csv需全部載完, 再加至render
            requests_list,
            data,
            key,
            callback
        ) {
            if (typeof data.url === 'string') {
                data.url = [data.url]
            }

            const csv_requests = data.url.map((url, i) => {
                const request = axios.get(url)
                requests_list.push(request)
                return request
            })

            axios
                .all(csv_requests)
                .then(
                    axios.spread((spd, dir, hgt) => {
                        const csv_data = this.format_data(
                            spd ? spd.data : null,
                            dir ? dir.data : null,
                            hgt ? hgt.data : null
                        )

                        callback(csv_data, key)
                    })
                )
                .catch(() => {
                    callback(null, key)
                })
        },
        insert_data: function(render, csv_data, key) {
            render.push(csv_data, key)
        },
        format_data: function(spd, dir, hgt) {
            let csv_data
            if (spd && dir && hgt) {
                //[速度,方向,高度], ex.multi
                csv_data = {
                    others: [spd, hgt],
                    dir: dir,
                    color: this.color_csv === 'spd' ? spd : hgt,
                }
            } else if (spd && dir) {
                //[速度,方向], ex.symbol
                csv_data = {
                    quantity: spd,
                    dir: dir,
                }
            } else {
                //[速度], ex.pixel
                csv_data = spd
            }

            return csv_data
        },
        load_data: function() {
            // load csv data
            let requests = []
            let requests_count = 0

            // if list = [1,2,3,4,5] => load 5=>1=>2=>3=>4
            let load_list = this.options.list.slice()
            load_list = [load_list.pop()].concat(load_list)

            load_list.forEach((data) => {
                requests_count++

                this.add_data({
                    data: data, //{key, url}
                    requests: requests,
                    callback: () => {
                        requests_count--
                        if (!requests_count) {
                            //  ★ all loaded
                            this.loaded()
                        }
                    },
                })
            })
        },
        loaded: function() {
            //全部載完後, 顯示最後一頁
            const last_key = this.options.list[this.options.list.length - 1].key
            this.pane.render.change(last_key)

            if (this.options.callback) {
                this.options.callback(this.layer_id)
            }
        },
        change: function(key) {
            //換頁
            this.render.change_by_key(key)
        },
        remove_render_layer: function() {
            this.pane.removeLayer(this.layer_id)
            this.is_layer_show = false
        },
        add_render_layer: function() {
            const canvas = this.render.getCanvas()
            this.layer._canvas = canvas
            this.layer.addTo(this.pane)
            this.is_layer_show = true

            this.set_layer_boundary()

            this.render.change_by_key(this.pane.render.last_key)
        },
    },
    watch: {
        render: function(render) {
            this.set_layer_boundary()
            this.set_color_status()
            this.set_colorbar(this.options, render)
            this.extend_pane_render()
            this.load_data()
        },
        pick_data: function(params) {
            if (!params) {
                return
            }

            let cursor_data = []
            let cursor_index = null

            if (['pixel', 'block'].includes(this.render_type)) {
                cursor_data = [params.data || params.color]
                cursor_index = params.data ? params.index : params.colorLv
            } else if (['symbol'].includes(this.render_type)) {
                cursor_data = [params.data.quantity, params.data.dir]
                cursor_index = params.index
            } else if (['multi'].includes(this.render_type)) {
                // multi => [hgt, spd, dir]
                cursor_data = [this.color_csv === 'spd' ? params.others[1] : params.color, params.others[0], params.dir]
                cursor_index = params.colorLv
            }

            this.colorbar[0].change_cursor(cursor_index, cursor_data)
        },
    },
    beforeDestroy: function() {
        KXD.utility.func.cnvBuffer.remove(this.name)
    },
}
</script>

<style scoped></style>
